import {useQuery} from 'react-query';

import {getNearestLabs} from '.';

export const useGetNearestLabs = (payload: INearestLabParams) => {
  const {data, isLoading} = useQuery(['get-nearest-labs', payload], () =>
    getNearestLabs(payload),
  );

  return {nearestLabs: data, nearestLabsIsLoading: isLoading};
};
